import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useFirestore} from 'react-redux-firebase'
import {Table, Popup, Icon, Label, Loader, Menu, Button, Placeholder} from 'semantic-ui-react'
import * as SportradarActions from '../../../actions/SportradarActions'
import * as moment from 'moment'

export function Live(props) {
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const livestats = useSelector((state) => !state.sportradar.hasIn(['live', props.id]) ? null : state.sportradar.getIn(['live', props.id]).toJS());

    useEffect(() => {
        dispatch(SportradarActions.load_live(firestore, props.id));
    }, [props.id])

    return (
        <div style={{
            overflow: 'auto',
            height: '100%'
        }}>
        {
            (livestats === null)?
                <Loader inline active />
            :
                <div>Live</div>
        }
        </div>
    )
}